import { UUID } from "angular2-uuid";
import { EsriOperationResponseDto } from "../dtos/esri-operation-response.dto";
import { BackgroundOperationViewModel } from "src/app/background-operations/models/view-models/background-operation.view-model";
import { RoutePlan } from "../../route-plan";
import { BackgroundOperationType } from "src/app/background-operations/models/enums/background-operation-type.enum";

/**
 * Represents a background operation specific to Esri route processing.
 * Examples include route optimization and ETA calculations.
 */
export class EsriBackgroundOperationViewModel extends BackgroundOperationViewModel {
	/** 
	 * Result data from processing (only populated on Success). 
	 */
	public ResultData: RoutePlan | null;

	/**
	 * The associated Route Plan Identifier for the Esri operation.
	 */
	public RoutePlanId: UUID;

	/**
	 * @constructor
	 * Initializes a new instance of the EsriBackgroundOperationViewModel class with the specified description and type. The status is set to Pending by default, and a unique ClientOperationId is generated for client-side tracking purposes.
	 * @param description A brief description of the operation for display purposes.
	 * @param operationType The type of background operation.
	 */
	public constructor(description: string, operationType: BackgroundOperationType, routePlanId: UUID)
	{
		super({Description: description, Type: operationType});
		this.ResultData = null;
		this.RoutePlanId = routePlanId;
	}

	/**
	 * Updates the properties of the EsriBackgroundOperationViewModel instance based on the provided EsriOperationResponseDto.
	 * @param dto The dto to update from
	 * @returns The updated instance of this EsriBackgroundOperationViewModel.
	 */
	public UpdateFromDto(dto: EsriOperationResponseDto): this {
		if (!dto.BackgroundOperationId) {
			throw new Error("Cannot map EsriOperationResponseDto to EsriBackgroundOperation: BackgroundOperationId is null");
		}
		super.UpdateFromDto(dto);
		return this;
	}
}